import React from 'react';
import type { PatientInfo } from '../types';

interface PatientInfoCardProps {
  patientInfo: PatientInfo;
}

const InfoItem: React.FC<{ label: string; value: string | undefined }> = ({ label, value }) => {
  if (!value) return null;
  return (
    <div>
      <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">{label}</p>
      <p className="text-sm font-semibold text-slate-800 pt-0.5">{value}</p>
    </div>
  );
};


const PatientInfoCard: React.FC<PatientInfoCardProps> = ({ patientInfo }) => {
  return (
    <div className="mb-10 border-b border-slate-200/80 pb-8">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-5">
        <div className="col-span-2 sm:col-span-1">
            <InfoItem label="Patient Name" value={patientInfo.name} />
        </div>
        <InfoItem label="Patient ID" value={patientInfo.patientId} />
        <InfoItem label="Age" value={patientInfo.age} />
        <InfoItem label="Gender" value={patientInfo.gender} />
        <InfoItem label="Accession #" value={patientInfo.accessionNumber} />
        <InfoItem label="Collected" value={patientInfo.receptionDate} />
        <InfoItem label="Reported" value={patientInfo.resultDate} />
        <InfoItem label="Referred By" value={patientInfo.referredBy} />
      </div>
    </div>
  );
};

export default PatientInfoCard;
